import * as React from "react";
import { cn } from "@/utils/shared";

export interface InputProps extends React.ComponentProps<"input"> {
  label?: string;
  leftElement?: React.ReactNode;
  rightElement?: React.ReactNode;
  divClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, divClassName, leftElement, rightElement, type, ...props }, ref) => {
    const inputLeftElementClass = leftElement ? "pl-11" : "";
    const inputRightElementClass = rightElement ? "pr-11" : "";
    return (
      <div className={divClassName}>
        <div className="relative">
          {leftElement && (
            <div className="absolute top-1/2 -translate-y-1/2 left-4">{leftElement}</div>
          )}
          <input
            type={type}
            className={cn(
              "text-ellipsis flex h-10 w-full rounded-xl border border-neutral-300 bg-transparent px-4 py-2.5 text-neutral-600 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-neutral-600 focus-visible:outline-hidden focus-visible:border-primary-600 focus-visible:ring-ring disabled:text-neutral-400 disabled:bg-disabled-50 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm invalid:border-error-400 invalid:text-error-400 aria-invalid:border-error-400 aria-invalid:text-error-400",
              inputLeftElementClass,
              inputRightElementClass,
              className
            )}
            label={props.label}
            ref={ref}
            {...props}
          />
          {rightElement && (
            <div className="absolute top-1/2 -translate-y-1/2 right-4">{rightElement}</div>
          )}
        </div>
      </div>
    );
  }
);
Input.displayName = "Input";

export { Input };
